import { History } from 'history';

const EXPORT_TO_NETSUITE_ALLOWED_ROLES = ["SUPERUSER", "MERCHOLOGIST"];


export function resolveDropdownOptions(
  merchstore: { storeCode: string, status: string },
  userRole: string,
  userEmail: string,
  history: History,
  dropDownOptions: any[]
) {

  if (merchstore.status !== 'closed') {
    return dropDownOptions;
  }

  const resolvedDropdownOptions = [
    {
      title: "View/Edit",
      id: `${merchstore.storeCode}-view`,
      action: () => {
        history.push(`/admin/group-orders/${merchstore.storeCode}`);
      }
    }
  ];

  if (EXPORT_TO_NETSUITE_ALLOWED_ROLES.includes(userRole)) {
    resolvedDropdownOptions.push(    {
      title: "Export to Netsuite",
      id: `${merchstore.storeCode}-export-netsuite`,
      action: () => {
        alert("This button should export to Netsuite")
        //TODO:  EXPORT RECIPIENT TO NETSUITE)
      }
    });
  }

  return resolvedDropdownOptions;
}

export default {
  resolveDropdownOptions

} 